// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");

let Types = {};

let variablesConverter = {"rentalPropertyDataInput":{"availableFrom":{"b":""}},"draftPriceRangeInput":{"minPrice":{"b":""},"maxPrice":{"b":""}},"saveListingDraftV5Input":{"property":{"r":"draftPropertyV5Input"}},"attachmentV5Input":{},"draftExactPriceInput":{"price":{"b":""}},"draftPropertyV5GeocodingDataInput":{},"forSalePropertyDataInput":{},"draftPropertyPriceInput":{"priceRange":{"r":"draftPriceRangeInput"},"exactPrice":{"r":"draftExactPriceInput"}},"draftPropertyV5Input":{"showings":{"r":"draftShowingV5Input"},"rentalProperty":{"r":"rentalPropertyDataInput"},"price":{"r":"draftPropertyPriceInput"},"onMlsAt":{"b":""},"images":{"r":"attachmentV5Input"},"geocodingData":{"r":"draftPropertyV5GeocodingDataInput"},"forSaleProperty":{"r":"forSalePropertyDataInput"},"files":{"r":"attachmentV5Input"}},"draftShowingV5Input":{"date":{"b":""}},"__root":{"input":{"r":"saveListingDraftV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"saveListingDraftV5":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"saveListingDraftV5":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function leaseLengthValue_decode($$enum) {
  if ($$enum === "LONG" || $$enum === "SHORT_OR_LONG" || $$enum === "SHORT") {
    return $$enum;
  }
}

let leaseLengthValue_fromString = leaseLengthValue_decode;

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: leaseLengthValue_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ChapterPreferencesV5",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mlsComingSoon",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "goingOnMls",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willAcceptOffers",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willShow",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mlsListingType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onMlsAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lon",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "DraftPropertyV5GeocodingData",
  "kind": "LinkedField",
  "name": "geocodingData",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardizedAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardizedCity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardizedState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "standardizedZip",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "width",
      "value": 300
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": "url(width:300)"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "DraftShowingV5",
  "kind": "LinkedField",
  "name": "showings",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    },
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": "typ",
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideAddress",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v29 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": (v29/*: any*/),
          "storageKey": null
        }
      ],
      "type": "DraftPropertyExactPrice",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "maxPrice",
          "plural": false,
          "selections": (v29/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "minPrice",
          "plural": false,
          "selections": (v29/*: any*/),
          "storageKey": null
        }
      ],
      "type": "DraftPropertyPriceRange",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyData",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "forSalePropertyType",
          "args": null,
          "kind": "ScalarField",
          "name": "propertyType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commission",
          "storageKey": null
        }
      ],
      "type": "DraftPropertyDataForSaleV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "rentalPropertyType",
          "args": null,
          "kind": "ScalarField",
          "name": "propertyType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availableFrom",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LeaseLengthV5",
          "kind": "LinkedField",
          "name": "leaseLength",
          "plural": false,
          "selections": (v29/*: any*/),
          "storageKey": null
        }
      ],
      "type": "DraftPropertyDataRentalV5",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "halfBaths",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingArea",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lotSize",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfUnits",
  "storageKey": null
},
v38 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "FULL"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"FULL\")"
  }
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v40 = [
  (v33/*: any*/),
  (v32/*: any*/),
  (v34/*: any*/),
  (v36/*: any*/),
  (v35/*: any*/),
  (v39/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willShowPriorToMls",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willAcceptOffersPriorToMls",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v44 = [
  (v14/*: any*/),
  (v15/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV5",
  "kind": "LinkedField",
  "name": "approximateCoordinates",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityRule",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV5",
  "kind": "LinkedField",
  "name": "coordinates",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v49 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v50 = {
  "kind": "Literal",
  "name": "width",
  "value": 1200
},
v51 = {
  "kind": "Literal",
  "name": "embed",
  "value": true
},
v52 = {
  "kind": "Literal",
  "name": "crop",
  "value": true
},
v53 = {
  "kind": "Literal",
  "name": "height",
  "value": 284
},
v54 = {
  "kind": "Literal",
  "name": "width",
  "value": 426
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertyWizardFormRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DraftV5",
        "kind": "LinkedField",
        "name": "saveListingDraftV5",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PropertyWizardFormRelay_inlineServerDraft",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PropertyWizardRelayPreview_serverDraft"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterV5",
                "kind": "LinkedField",
                "name": "chapter",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftPropertyV5",
                "kind": "LinkedField",
                "name": "draftProperty",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FileAttachment",
                    "kind": "LinkedField",
                    "name": "files",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageAttachment",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Area",
                    "kind": "LinkedField",
                    "name": "displayNeighborhood",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Area",
                    "kind": "LinkedField",
                    "name": "userSelectedArea",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "PropertyWizardFormRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DraftV5",
        "kind": "LinkedField",
        "name": "saveListingDraftV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftPropertyV5",
            "kind": "LinkedField",
            "name": "draftProperty",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PropertyPreviewHelpers",
                "kind": "LinkedField",
                "name": "previewHelpers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isPropertyPrice"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "minPrice",
                            "plural": false,
                            "selections": (v38/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "maxPrice",
                            "plural": false,
                            "selections": (v38/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "PriceRange",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v38/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "ExactPrice",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LeaseLengthV5",
                    "kind": "LinkedField",
                    "name": "leaseLength",
                    "plural": false,
                    "selections": [
                      (v39/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CondoProperty",
                    "kind": "LinkedField",
                    "name": "condoProperty",
                    "plural": false,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LotProperty",
                    "kind": "LinkedField",
                    "name": "lotProperty",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "size",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lotSize",
                        "storageKey": null
                      },
                      (v39/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultiUnitProperty",
                    "kind": "LinkedField",
                    "name": "multiUnitProperty",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v39/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SingleFamilyProperty",
                    "kind": "LinkedField",
                    "name": "singleFamilyProperty",
                    "plural": false,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "mlsPlan",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isMlsPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/)
                        ],
                        "type": "ListOnMlsAsActive",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activeOnMlsOn",
                            "storageKey": null
                          },
                          (v41/*: any*/),
                          (v42/*: any*/)
                        ],
                        "type": "ListOnMlsAsComingSoon",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/)
                        ],
                        "type": "NoMlsPlan",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "propertyLocation",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isPropertyLocation"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          (v45/*: any*/)
                        ],
                        "type": "PropertyLocationWithHiddenAddress",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v46/*: any*/),
                          (v43/*: any*/),
                          (v24/*: any*/),
                          (v47/*: any*/)
                        ],
                        "type": "PropertyLocationWithVisibleAddress",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShowingV5",
                    "kind": "LinkedField",
                    "name": "showings",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      (v48/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDateV2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDateV2",
                        "storageKey": null
                      },
                      {
                        "alias": "type_",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emailAddress",
                        "storageKey": null
                      },
                      (v39/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brokerage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "profilePhoto",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              (v49/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 60
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "membershipStatus",
                        "storageKey": null
                      },
                      (v48/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PropertyLocationWithHiddenAddress",
                    "kind": "LinkedField",
                    "name": "hiddenPropertyLocation",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v28/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v46/*: any*/),
                              (v47/*: any*/)
                            ],
                            "type": "PropertyLocationWithVisibleAddress",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v45/*: any*/)
                            ],
                            "type": "PropertyLocationWithHiddenAddress",
                            "abstractKey": null
                          }
                        ],
                        "type": "PropertyLocation",
                        "abstractKey": "__isPropertyLocation"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageAttachment",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      {
                        "alias": "carouselFullscreen",
                        "args": [
                          (v49/*: any*/),
                          (v50/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "carouselLarge",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 800
                          },
                          (v49/*: any*/),
                          (v50/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "carouselSmall",
                        "args": [
                          (v51/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 500
                          },
                          (v49/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 750
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "carouselThumb",
                        "args": [
                          (v52/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 90
                          },
                          (v49/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 90
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "large",
                        "args": [
                          (v52/*: any*/),
                          (v51/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 720
                          },
                          (v49/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 1288
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "medium",
                        "args": [
                          (v52/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 574
                          },
                          (v49/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 861
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "small",
                        "args": [
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v49/*: any*/),
                          (v54/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "imgUrl",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "crop",
                            "value": false
                          },
                          (v51/*: any*/),
                          (v53/*: any*/),
                          (v49/*: any*/),
                          (v54/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v48/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FileAttachment",
                    "kind": "LinkedField",
                    "name": "files",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v48/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FileAttachment",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v48/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageAttachment",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v48/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Area",
                "kind": "LinkedField",
                "name": "displayNeighborhood",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v17/*: any*/),
                  (v48/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Area",
                "kind": "LinkedField",
                "name": "userSelectedArea",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v26/*: any*/),
                  (v48/*: any*/)
                ],
                "storageKey": null
              },
              (v27/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ChapterV5",
            "kind": "LinkedField",
            "name": "chapter",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v48/*: any*/)
            ],
            "storageKey": null
          },
          (v48/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc5fc577d2519fa965e90d9543da534d",
    "id": null,
    "metadata": {},
    "name": "PropertyWizardFormRelayMutation",
    "operationKind": "mutation",
    "text": "mutation PropertyWizardFormRelayMutation(\n  $input: SaveListingDraftV5Input!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  saveListingDraftV5(input: $input) {\n    ...PropertyWizardFormRelay_inlineServerDraft\n    nodeId\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  membershipStatus\n}\n\nfragment AgentPropertyLocation_propertyLocation on PropertyLocation {\n  __isPropertyLocation: __typename\n  __typename\n  ... on PropertyLocationWithHiddenAddress {\n    locationDisplay\n  }\n  ... on PropertyLocationWithVisibleAddress {\n    visibilityRule\n    locationDisplay\n    address\n  }\n}\n\nfragment AgentPropertyMlsStatus_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on AlreadyOnMls {\n    __typename\n  }\n  ... on ListOnMlsAsActive {\n    onMlsAt\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n  }\n  ... on NoMlsPlan {\n    willShow\n  }\n}\n\nfragment AllImages_image on ImageAttachment {\n  imgUrl: url(width: 426, height: 284, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  key\n}\n\nfragment CondoPropertyAttributes_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSize\n  livingArea\n  displayName\n}\n\nfragment ContactAgentButton_agent on Agent {\n  phone\n  emailAddress\n  displayName\n}\n\nfragment FileList_file on FileAttachment {\n  contentType\n  fileName\n  url\n}\n\nfragment FileList_files on FileAttachment {\n  ...FileList_file\n}\n\nfragment ImageGallery_image on ImageAttachment {\n  carouselFullscreen: url(width: 1200, ratio: $__relay_internal__pv__DevicePixelRatio)\n  carouselLarge: url(width: 1200, height: 800, ratio: $__relay_internal__pv__DevicePixelRatio)\n  carouselSmall: url(width: 750, height: 500, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  carouselThumb: url(width: 90, height: 90, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  ...ImageGrid_image\n  ...AllImages_image\n}\n\nfragment ImageGridImage_image on ImageAttachment {\n  large: url(width: 1288, height: 720, crop: true, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  medium: url(width: 861, height: 574, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n  small: url(width: 426, height: 284, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n}\n\nfragment ImageGrid_image on ImageAttachment {\n  ...ImageGridImage_image\n}\n\nfragment LotPropertyAttributes_lotProperty on LotProperty {\n  size: lotSize\n  displayName\n}\n\nfragment MultiUnitPropertyAttributes_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment PropertyLocationMapInner_location on PropertyLocation {\n  __isPropertyLocation: __typename\n  __typename\n  ... on PropertyLocationWithVisibleAddress {\n    visibilityRule\n    coordinates {\n      lat\n      lon\n    }\n  }\n  ... on PropertyLocationWithHiddenAddress {\n    approximateCoordinates {\n      lat\n      lon\n    }\n  }\n}\n\nfragment PropertyPageForSalePropertySidecardMlsInfo_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on ListOnMlsAsActive {\n    onMlsAt\n    willShowPriorToMls\n    willAcceptOffersPriorToMls\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n    willShowPriorToMls\n    willAcceptOffersPriorToMls\n  }\n  ... on NoMlsPlan {\n    willShow\n    willAcceptOffers\n  }\n}\n\nfragment PropertyPageNextShowing_showing on ShowingV5 {\n  startDate\n}\n\nfragment PropertyPageRentalPropertySidecardMlsInfo_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on ListOnMlsAsActive {\n    onMlsAt\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n  }\n  ... on NoMlsPlan {\n    __typename\n  }\n}\n\nfragment PropertyPageShowingsList_showing on ShowingV5 {\n  startDateV2\n  endDateV2\n  type_: type\n  notes\n}\n\nfragment PropertyPageShowingsList_showings on ShowingV5 {\n  id\n  ...PropertyPageShowingsList_showing\n}\n\nfragment PropertyPrice_propertyPrice_4wzfKn on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: FULL)\n    }\n    maxPrice {\n      formatted(format: FULL)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment PropertyWizardFormRelay_inlineServerDraft on DraftV5 {\n  ...PropertyWizardRelayPreview_serverDraft\n  databaseId\n  subject\n  status\n  message\n  chapter {\n    timezone\n    preferences {\n      mlsComingSoon\n    }\n    nodeId\n  }\n  draftProperty {\n    website\n    goingOnMls\n    willAcceptOffers\n    willShow\n    mlsListingType\n    onMlsAt\n    geocodingData {\n      lat\n      lon\n      standardizedAddress\n      standardizedCity\n      standardizedState\n      standardizedZip\n    }\n    files {\n      id\n      key\n      fileName\n      contentType\n      nodeId\n    }\n    images {\n      id\n      key\n      fileName\n      contentType\n      url(width: 300)\n      nodeId\n    }\n    showings {\n      id\n      key\n      date\n      endTime\n      notes\n      startTime\n      typ: type\n    }\n    address\n    description\n    displayNeighborhood {\n      label\n      id\n      nodeId\n    }\n    userSelectedArea {\n      id\n      label\n      nodeId\n    }\n    hideAddress\n    price {\n      __typename\n      ... on DraftPropertyExactPrice {\n        price {\n          value\n        }\n      }\n      ... on DraftPropertyPriceRange {\n        maxPrice {\n          value\n        }\n        minPrice {\n          value\n        }\n      }\n    }\n    propertyData {\n      __typename\n      ... on DraftPropertyDataForSaleV5 {\n        forSalePropertyType: propertyType\n        commission\n      }\n      ... on DraftPropertyDataRentalV5 {\n        rentalPropertyType: propertyType\n        availableFrom\n        leaseLength {\n          value\n        }\n      }\n    }\n    baths\n    beds\n    halfBaths\n    livingArea\n    lotSize\n    numberOfUnits\n  }\n}\n\nfragment PropertyWizardRelayPreviewFiles_previewHelpers on PropertyPreviewHelpers {\n  files {\n    ...FileList_files\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewImageGrid_displayHelpers on PropertyPreviewHelpers {\n  images {\n    ...ImageGallery_image\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewListingDetails_previewHelpers on PropertyPreviewHelpers {\n  showings {\n    startDate\n    nodeId\n  }\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n      willShowPriorToMls\n      willAcceptOffersPriorToMls\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n      willShowPriorToMls\n      willAcceptOffersPriorToMls\n    }\n    ... on NoMlsPlan {\n      willShow\n      willAcceptOffers\n    }\n  }\n  website\n}\n\nfragment PropertyWizardRelayPreviewLocation_displayHelpers on PropertyPreviewHelpers {\n  propertyLocation {\n    __typename\n    ...PropertyLocationMapInner_location\n  }\n  hiddenPropertyLocation {\n    ...PropertyLocationMapInner_location\n  }\n}\n\nfragment PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers on PropertyPreviewHelpers {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers on PropertyPreviewHelpers {\n  propertyLocation {\n    __typename\n    ...AgentPropertyLocation_propertyLocation\n  }\n}\n\nfragment PropertyWizardRelayPreviewPropertyDetails_displayHelpers on PropertyPreviewHelpers {\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_4wzfKn\n  }\n  leaseLength {\n    displayName\n  }\n  condoProperty {\n    ...CondoPropertyAttributes_condoProperty\n  }\n  lotProperty {\n    ...LotPropertyAttributes_lotProperty\n  }\n  multiUnitProperty {\n    ...MultiUnitPropertyAttributes_multiUnitProperty\n  }\n  singleFamilyProperty {\n    ...SingleFamilyPropertyAttributes_singleFamilyProperty\n  }\n  mlsPlan {\n    __typename\n    ...AgentPropertyMlsStatus_mlsPlan\n  }\n  ...PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers\n}\n\nfragment PropertyWizardRelayPreviewShowingsList_displayHelpers on PropertyPreviewHelpers {\n  showings {\n    ...PropertyPageShowingsList_showings\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreviewSidecard_displayHelpers on PropertyPreviewHelpers {\n  showings {\n    ...PropertyPageNextShowing_showing\n    nodeId\n  }\n  agent {\n    ...ContactAgentButton_agent\n    ...AgentInfo_agent\n    nodeId\n  }\n  mlsPlan {\n    __typename\n    ...PropertyPageForSalePropertySidecardMlsInfo_mlsPlan\n    ...PropertyPageRentalPropertySidecardMlsInfo_mlsPlan\n  }\n}\n\nfragment PropertyWizardRelayPreview_displayHelpers on PropertyPreviewHelpers {\n  ...PropertyWizardRelayPreviewPropertyDetails_displayHelpers\n  ...PropertyWizardRelayPreviewSidecard_displayHelpers\n  ...PropertyWizardRelayPreviewShowingsList_displayHelpers\n  ...PropertyWizardRelayPreviewLocation_displayHelpers\n  ...PropertyWizardRelayPreviewImageGrid_displayHelpers\n  ...PropertyWizardRelayPreviewListingDetails_previewHelpers\n  ...PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers\n  ...PropertyWizardRelayPreviewFiles_previewHelpers\n  files {\n    __typename\n    nodeId\n  }\n  images {\n    __typename\n    nodeId\n  }\n}\n\nfragment PropertyWizardRelayPreview_serverDraft on DraftV5 {\n  draftProperty {\n    previewHelpers {\n      ...PropertyWizardRelayPreview_displayHelpers\n    }\n  }\n}\n\nfragment SingleFamilyPropertyAttributes_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSize\n  livingArea\n  displayName\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
